import type {
  UsersSelectOptionItemData,
  UsersSelectOptionItem,
} from "./users-select.type";

export const getUsersSelectOptionItemValue = (
  user: UsersSelectOptionItemData
) => user.id;

export const getUsersSelectOptionItemLabel = (
  user: UsersSelectOptionItemData
) => `${user.name} (${user.email})`;

export const getUsersSelectOptionItem = (
  user: UsersSelectOptionItemData
): UsersSelectOptionItem => ({
  value: getUsersSelectOptionItemValue(user),
  label: getUsersSelectOptionItemLabel(user),
});
